
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import _ from 'lodash'
import BigBreadcrumbs from '../../../components/layout/navigation/components/BigBreadcrumbs'
import WidgetGrid from '../../../components/layout/widgets/WidgetGrid'
import JarvisWidget from '../../../components/layout/widgets/JarvisWidget'
import Datatable from '../../../components/tables/Datatable'
import { addFeaturedSeller, allRetailerFunc, fetchAllRetailers, fetchRetailers, removeFeaturedSeller } from '../../../common/actions/retailer'
import { statusCodeToText } from '../../../common/utils/retailer'
import { LIST_PAGE_LENGTH } from '../../../common/constants'

import styles from './List.module.css'
import classNames from 'classnames'

const renderName = name => `
  <div class="${styles.nameColumn}">
    <div class="${styles.expandButton}">+</div>
    <span>${name}</span>
  </div>
`
const renderStatus = statusCode => _.capitalize(statusCodeToText(statusCode))

const renderVerified = data => (data.verified ? 'Yes' : 'No')


const renderCity = (data, type, row) => {
  if (data) {
    return data
  }
  if (row['gmapSublocality']) {
    return row['gmapSublocality']
  }
  for (let i = 1; i <= 5; i++) {
    if (row[`gmapSublocality${i}`]) {
      return row[`gmapSublocality${i}`]
    }
  }
  return ''
}

function FeaturedList({ fetchRetailers, retailers, addFeatured, removeFeatured, retailer, retailerInProgress }) {
  const navigate = useNavigate()
  const location = useLocation()
  const containerRef = useRef(null)
  const prevLocationRef = useRef(null)

  useEffect(() => {
    const prevLocation = prevLocationRef.current
    prevLocationRef.current = location
    if (!prevLocation) return
    const prevPage = new URLSearchParams(prevLocation.search).get('page')
    const currPage = new URLSearchParams(location.search).get('page')
    if (!retailers || prevPage !== currPage || retailerInProgress) {
      return
    }
    const nextPageInt = parseInt(currPage, 10)
    let page = retailers.getMeta('pageNumber')
    if (page === 0 || !page) page = 1
    if (nextPageInt !== page) {
      const params = new URLSearchParams(location.search)
      params.set('page', page)
      if (currPage) {
        navigate({ pathname: location.pathname, search: params.toString() })
      } else {
        navigate({ pathname: location.pathname, search: params.toString() }, { replace: true })
      }
    }
  }, [location, retailers, retailerInProgress])

  useEffect(() => {
    const handleEditClick = (e) => {
      const anchor = e.target.closest('a[data-spa-href]')
      if (!anchor) return
      e.preventDefault()
      navigate(anchor.getAttribute('data-spa-href'))
    }
    const node = containerRef.current
    if (node) node.addEventListener('click', handleEditClick)
    return () => {
      if (node) node.removeEventListener('click', handleEditClick)
    }
  }, [])

  let page = retailers ? retailers.getMeta('pageNumber') : parseInt(new URLSearchParams(location.search).get('page'))
  page = _.isInteger(page) ? Math.max(page, 1) : 1
  const displayStart = (page - 1) * LIST_PAGE_LENGTH

  const renderId = id => {
    const searchParams = new URLSearchParams(location.search)
    if (retailers) {
      const q = retailers.getMeta('query')
      if (q) searchParams.set('query', q)
    }
    const pathWithSearch = location.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '')
    const backUrl = encodeURIComponent(pathWithSearch)
    const [createdDay, retailerUuid] = id.split('/')
    const href = `/retailers/${encodeURIComponent(createdDay)}/${encodeURIComponent(retailerUuid)}/edit?backUrl=${backUrl}`
    return `<a href="${href}" data-spa-href="${href}">Edit</a>`
  }

  return (
      <div id="content" className={styles.listWrapper} ref={containerRef}>
        <div className="row">
          <BigBreadcrumbs
            items={['Featured sellers']}
            icon="table"
            className="col-xs-12 col-sm-7 col-md-7 col-lg-4"
          />
          {/* <button
            className={`btn btn-primary pull-right ${styles.addButton}`}
            onClick={() => {
              navigate('/retailers/new')
            }}
          >
            Add a Retailer
          </button> */}
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                editbutton={false}
                togglebutton={false}
                fullscreenbutton={false}
                deletebutton={false}
                color="darken"
              >
                <header>
                  <span className="widget-icon">
                    <i className="fa fa-list" />
                  </span>
                  {/* <h2>Retailers</h2> */}
                  <h2>Featured sellers</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <Datatable
                      options={{
                        processing: true,
                        serverSide: true,
                        ajax: fetchRetailers,
                        lengthChange: false,
                        pageLength: LIST_PAGE_LENGTH,
                        displayStart,
                        search: {
                          search: new URLSearchParams(location.search).get('query')
                        },
                        columns: [
                          { data: 'name', render: renderName },
                          {
                            data: 'isFeatured',
                            render: (data, type, row) => {
                              return `<div class="form-check form-switch">
                                        <input 
                                          id="check-toggle-${row.retailerId}" 
                                          class="form-check-input toggle-feature" 
                                          type="checkbox" 
                                          role="switch" 
                                          data-id="${row.retailerId}" 
                                          ${data === true || data === 1 ? 'checked' : ''}>
                                        <label for="check-toggle-${row.retailerId}"></label>
                                      </div>`;
                            }
                          },
                          { data: 'statusCode', render: renderStatus },
                          { data: null, render: renderVerified },
                          { data: 'gmapStreetAddr' },
                          { data: 'gmapLocality', render: renderCity },
                          { data: 'gmapCountry' },
                          { data: 'phone' },
                          { data: 'email' }
                          // { data: 'id', render: renderId }
                        ],
                        drawCallback: function () {
                          // Attach event listener for toggle switches after rendering
                          $('.toggle-feature').off('change').on('change', function () {
                            const retailerId = $(this).data('id'); // Get retailer ID from data-id
                            const isChecked = $(this).is(':checked'); // Check if toggled on/off
                            const data = {
                              retailer_id: retailerId
                            }
                            if (isChecked) {
                              addFeatured(data).then((res) => {
                                // console.log(res, 'res++')
                                retailer(LIST_PAGE_LENGTH)
                              })
                            } else {
                              removeFeatured(data).then((res) => {
                                // console.log(res, 'res++')
                                retailer(LIST_PAGE_LENGTH)
                              })
                            }
                          });
                        },
                        autoWidth: false,
                        responsive: { details: { type: 'inline' } },
                      }}
                      searchPlaceholder={`Name or email`}
                      className={classNames("table table-striped table-bordered table-hover", styles.table)}
                      width="100%"
                    >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Featured</th>
                          <th>Status</th>
                          <th>Verified</th>
                          <th>Street Address</th>
                          <th>City</th>
                          <th>Country</th>
                          <th>Phone</th>
                          <th>Email</th>
                          {/* <th>Actions</th> */}
                        </tr>
                      </thead>
                    </Datatable>
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    )
}

const mapStateToProps = ({ retailer }) => ({
  retailers: retailer.get('retailers'),
  retailerInProgress: retailer.get('inProgress')
})

const mapDispatchToProps = dispatch => {
  return {
    fetchRetailers(query, callback) {
      dispatch(
        fetchRetailers(query, retailers => {
          setTimeout(() => {
            try {
              if (!retailers) {
                callback({ recordsTotal: 0, recordsFiltered: 0, data: [] })
                return
              }
              const recordsTotal = retailers.getMeta('recordsTotal') || 0
              callback({
                recordsTotal,
                recordsFiltered: recordsTotal,
                data: (retailers.toJSON() || [])
                  .map(item => _.extend(item.attributes, { id: item.id }))
              })
            } catch (e) {
              console.error('DataTable fetch error:', e)
              callback({ recordsTotal: 0, recordsFiltered: 0, data: [] })
            }
          })
        }, true) // only sellers who completed Stripe onboarding can be featured
      )
    },
    addFeatured: (data) => dispatch(addFeaturedSeller(data)),
    removeFeatured: (data) => dispatch(removeFeaturedSeller(data)),
    retailer: (page) => dispatch(allRetailerFunc(page))

  }


}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedList)
